import BaseSearchResultsView from 'component/quick_search/view/base_search_results'
import CommunitySearchResultView from 'component/quick_search/view/community_search_result'

const CommunitySearchResultsView = BaseSearchResultsView.extend({
    ItemView: CommunitySearchResultView,
})

export default CommunitySearchResultsView
